import moduleAppointment from "./appointment";
import moduleBranch from "./branch";
import moduleMaster from "./master";
import moduleUser from "./user";
import modulePatient from "./patient";
import moduleContent from "./content";
import moduleTreatment from "./treatment";
import moduleReceipt from "./receipt";
import moduleReport from "./report";
import moduleLab from "./lab";
import moduleAuth from "./auth";
import moduleCariesRiskAssessment from "./cariesRiskAssessment";
import moduleTreatmentPlan from "./treatmentPlan";
import moduleMediaFile from "./mediaFile";
import moduleTTD from "./TTD";
import moduleFhir from "./FHIR";
import moduleAiAnalysis from "./aiAnalysis";
import modulePayment from "./payment";
import moduleAudioAPI from "./audioAPI";
import moduleDeposit from "./deposit";
import dentalAI from "./dentalAI";
import protocolMedia from "./protocolMedia";
import moduleSuperadmin from "./superadmin";
import moduleCategoryMaster from "./ProductAndStock/categoryMaster";
import moduleUnitMaster from "./ProductAndStock/unitMaster";
import moduleProductInventory from "./ProductAndStock/productInventory";
import moduleDebtor from "./debtor";
import moduleTransferInventory from "./ProductAndStock/transferInventory";
import moduleGoodsReceive from "./ProductAndStock/goodsReceive";
import moduleDevice from "./device";
import moduleDiscount from "./discount";
import moduleDfCorrection from "./dfCorrection";

export default {
  moduleAppointment,
  moduleBranch,
  moduleMaster,
  moduleUser,
  modulePatient,
  moduleContent,
  moduleTreatment,
  moduleReceipt,
  moduleReport,
  moduleLab,
  moduleAuth,
  moduleCariesRiskAssessment,
  moduleTreatmentPlan,
  moduleMediaFile,
  moduleTTD,
  moduleFhir,
  moduleAiAnalysis,
  modulePayment,
  moduleAudioAPI,
  dentalAI,
  protocolMedia,
  moduleSuperadmin,
  moduleDeposit,
  //Product and stock
  moduleCategoryMaster,
  moduleUnitMaster,
  moduleProductInventory,
  moduleTransferInventory,
  moduleDebtor,
  moduleGoodsReceive,
  moduleDevice,
  moduleDiscount,
  moduleDfCorrection,
};
